import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CreateExplorePlan } from 'models/createExplorePlan';
import { Performer } from 'models/performer';
import { ExplorePlansService } from 'services/ExplorePlans.service';
import { v4 as uuid } from 'uuid';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-custom-performer-modal',
  templateUrl: './custom-performer-modal.component.html',
  styleUrls: ['./custom-performer-modal.component.scss']
})
export class CustomPerformerModalComponent implements OnInit {
  public onPlanCreated: Subject<boolean> = new Subject<boolean>();
  addCustomPerformersForm: FormGroup;
  submitted: boolean;
  submitting: boolean;
  performers: Performer[];
  selectedPerfomers: Performer[];
  error: string;

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private explorePlansService: ExplorePlansService, public toastr: ToastrService) { }

  ngOnInit() {
    this.explorePlansService.getActivePerformers().subscribe(performers => {
      this.performers = performers
    })

    this.addCustomPerformersForm = this.formBuilder.group({
      description: ['', [Validators.required, Validators.minLength(4)]],
      expiryDate: [new Date(), Validators.required],
      performerIds: [[], [Validators.required, Validators.minLength(1)]],
      image: [undefined, Validators.required]
    });
  }

  imageEvent(image) {
    this.addCustomPerformersForm.patchValue({image})
  }

  get formValue() {
    return this.addCustomPerformersForm.value as CreateExplorePlan;
  }

  get f() {
    return this.addCustomPerformersForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.addCustomPerformersForm.invalid) {
      return
    }

    this.submitting = true;
    const image = (this.formValue as any).image
    this.explorePlansService.getImageUploadUrl(image.fileName, image.uuid).subscribe(res => {
      this.explorePlansService.putImageUploadUrl(res.url, image.url, image.fileName).subscribe(r => {
        const dto = Object.assign({}, this.formValue)
        dto.id = uuid()
        dto.imageId = image.uuid
        dto.expiryDate = Math.floor(new Date(this.formValue.expiryDate).setHours(23, 59, 59, 999).valueOf() / 1000)
        dto.action = "ExplorePlanActionCustomPerformers"
    
        this.explorePlansService.createExplorePlan(dto).subscribe(res => {
          this.bsModalRef.hide()
          this.toastr.success('Customer Performer Item Saved', 'Success!')
          this.onPlanCreated.next(true);
        }, err => {
          this.submitting = false
          this.error = err.error ? err.error.message : err.message
        });
      })
    })
  }
}
